module.exports = __webpack_public_path__ + "img/meet_friend.dfd740c5.png";